import { useQuery } from '@tanstack/react-query';
import { useTacticHooks } from '../providers/TacticHooksProvider';
import { PageSectionFilter } from '@gettactic/api';

export const usePageSectionsQuery = (filter?: PageSectionFilter) => {
  const { apiClient } = useTacticHooks();
  const sections = useQuery({
    queryKey: ['usePageSectionsQuery', apiClient.slug, filter],

    queryFn: async () => {
      const res = await apiClient.pages.getSections();
      return res.result;
    },

    enabled: !!apiClient.slug
  });

  return sections;
}
